// lib/nanoBanana.ts
// Nano Banana 2.1 runs on Nano Banana 2's contract: params, ratios, references, routing and price.
export const isNanoBanana2OrNewer = (model: string): model is 'nano-banana-2' | 'nano-banana-2.1' =>
  model === 'nano-banana-2' || model === 'nano-banana-2.1';
